import React from 'react';

import { useIntl } from 'react-intl';
import { PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

import usePhotoUploadInput from './hooks/usePhotoUploadInput';
import type { PhotoUploadInputProps } from './PhotoUploadInput.types';

const PhotoUploadInput = ({ inputId, maxCount, origin, ...hookParams }: PhotoUploadInputProps) => {
  const intl = useIntl();
  const { beforeUpload, fileList, onFileListChange, removePhoto, uploadPhoto } =
    usePhotoUploadInput({ maxCount, ...hookParams });

  return (
    <Upload
      accept="image/*"
      aria-label={intl.formatMessage({ id: 'general.upload' })}
      beforeUpload={beforeUpload}
      capture={origin === 'capture' ? 'environment' : undefined}
      customRequest={uploadPhoto}
      fileList={fileList}
      id={inputId}
      listType="picture-card"
      maxCount={maxCount}
      multiple={!maxCount || maxCount > 1}
      onChange={onFileListChange}
      onRemove={removePhoto}
    >
      {(!maxCount || fileList.length < maxCount) && (
        <div>
          <PlusOutlined />
          <div>
            <IntlMessages id="general.upload" />
          </div>
        </div>
      )}
    </Upload>
  );
};

export default PhotoUploadInput;
